// subscription-selector.js
// Synchronisiert die Abo-Auswahl (Radio-Buttons) mit dem versteckten
// "selling_plan" Feld im Produktformular, damit beim Klick auf
// "In den Warenkorb" der richtige Abo-Plan mitgeschickt wird.

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.subscription-selector').forEach(function (widget) {
    const hiddenInput = widget.querySelector('input[type="hidden"][name="selling_plan"]');
    const radios = widget.querySelectorAll('input[name="selling_plan_choice"]');

    // Findet das umgebende Produktformular (funktioniert mit den meisten
    // Standard- und customized Themes, notfalls den nächsten <form> Vorfahren nehmen)
    const form = widget.closest('form[action*="/cart/add"]') || widget.closest('form');

    function updateHiddenInput(value) {
      if (hiddenInput) {
        hiddenInput.value = value;
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateHiddenInput(radio.value);
      });
    });

    // Initialwert setzen (falls z.B. "requires_selling_plan" ein Abo vorauswählt)
    const checked = widget.querySelector('input[name="selling_plan_choice"]:checked');
    if (checked) {
      updateHiddenInput(checked.value);
    }

    // Falls euer Theme den Warenkorb per AJAX befüllt (kein normaler
    // Formular-Submit), stellt sicher, dass das Formular den hiddenInput-Wert
    // beim Absenden mit ausliest. Die meisten Themes tun das automatisch,
    // solange das Feld innerhalb des <form>-Tags liegt.
  });
});